import { render, staticRenderFns } from "./communitymy.vue?vue&type=template&id=40b3e53b&scoped=true"
import script from "./communitymy.vue?vue&type=script&lang=js"
export * from "./communitymy.vue?vue&type=script&lang=js"
import style0 from "./communitymy.vue?vue&type=style&index=0&id=40b3e53b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b3e53b",
  null
  
)

export default component.exports